export default __webpack_public_path__ + "static/media/Dickcatz-AwardWinner.b6ef95e8.svg";